import { memo, useCallback } from "react";

import type { ForNodeType } from "@/components/features/_model/types";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

type Props = {
	// ディスカウント金額（一定割合）
	ratio: ForNodeType<number>;

	// ディスカウント金額の変更（一定割合）
	onChangeDiscountWithRatio: (ratio: number) => void;
};

export const OrdinaryWithRatio = memo(({ ratio, onChangeDiscountWithRatio }: Props) => {
	/**
	 * ディスカウント金額の変更（一定割合）
	 */
	const handleChangeDiscountWithRatio = useCallback(
		(value?: number) => {
			onChangeDiscountWithRatio(value!);
		},
		[onChangeDiscountWithRatio],
	);

	return (
		<div className="flex items-center gap-x-3">
			<p>通常料金から</p>

			<InputNumberField
				handleInput={handleChangeDiscountWithRatio}
				value={ratio.value}
				errorMessage={ratio.error}
				hiddenSpinButton={false}
			/>

			<p>％割引</p>
		</div>
	);
});
